<div *ngIf="!loading" fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
    <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
      <h2 class="noMarginHeader" *ngIf="individual.id > 0">
        <mat-icon>edit</mat-icon> Edit {{individual.lastName}}
      </h2>
      <h2 class="noMarginHeader" *ngIf="individual.id == 0">
        <mat-icon>add</mat-icon> Add Certified Individual
      </h2>
    </div>
    
    <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="end">
      <button type="submit" (click)="onSubmit()" mat-raised-button color="primary"
        title="{{buttonText}}">{{buttonText}}</button>
      &nbsp;&nbsp;
      <button mat-button mat-dialog-close="Cancel" aria-label="Cancel" mat-raised-button color="basic"
        title="Close">Close</button>
        &nbsp;&nbsp;
    </div>
  </div>
  <mat-dialog-content *ngIf="!loading">
    <form #form="ngForm" [formGroup]="individualForm" class="form-field-full">
      <br />
      <span *ngIf="postErrorMessages != ''" class="error">{{postErrorMessages}}<br /><br /></span>
      <div fxLayout="row wrap" class="matero-row">
        <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
          <mat-card fxFlex="100">
            <div fxLayout="row wrap" class="matero-row" fxLayoutGap="8px grid" fxWrap>
              <div fxFlex="33.33%" fxFlex.lt-md="50%" fxFlex.lt-sm="100%" fxLayout="column" *ngFor="let field of objectKeys(formFields)">
                <ng-container [ngSwitch]="formFields[field].type">
                  <mat-form-field fxFlex *ngSwitchCase="'string'">
                    <input matInput [formControlName]="field" [placeholder]="formFields[field].name">
                  </mat-form-field>
                  <mat-form-field fxFlex *ngSwitchCase="'date'">
                    <input matInput [matDatepicker]="picker" [formControlName]="field" [placeholder]="formFields[field].name">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                  <mat-select *ngSwitchCase="'option'" [formControlName]="field" [placeholder]="lbpaFormFields[field].name">
                    <mat-option *ngFor="let option of lbpaFormFields[field].data" [value]="option">{{option}}</mat-option>
                  </mat-select>
                  <mat-checkbox *ngSwitchCase="'boolean'" [formControlName]="field">{{ formFields[field].name }}</mat-checkbox>                  
                </ng-container>
              </div>              
            </div>              
          </mat-card>
        </div>
      </div>
    </form>
  </mat-dialog-content>